"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataContext = void 0;
exports.DataProvider = DataProvider;
exports.useData = useData;
var _react = _interopRequireWildcard(require("react"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _startCase = _interopRequireDefault(require("lodash/startCase"));
var _api = require("../utils/api");
var _array = require("../utils/array");
var _storage = require("../utils/storage");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DataContext = exports.DataContext = /*#__PURE__*/_react["default"].createContext();
function useData() {
  return (0, _react.useContext)(DataContext);
}
function DataProvider(props) {
  if (props.data instanceof Error) {
    throw props.data;
  }
  var _useState = (0, _react.useState)(getLocal() || props.data || getData()),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    publishing = _useState4[0],
    setPublishing = _useState4[1];

  // Fields

  function getFields() {
    return data.fields || [];
  }
  function getField(name) {
    return getFields().find(function (field) {
      return field.name === name;
    });
  }
  function getFieldValue(name) {
    var _getField;
    return (_getField = getField(name)) === null || _getField === void 0 ? void 0 : _getField.value;
  }
  function updateField(update) {
    var fields = getFields();
    var index = fields.findIndex(function (field) {
      return field.name === update.name;
    });
    if (index === -1) {
      fields = [].concat(_toConsumableArray(fields), [update]);
    } else {
      fields = (0, _array.replaceElement)(fields, index, update);
    }
    mergeData({
      fields: fields
    });
  }

  // Field Types

  function setFieldType(name, type) {
    var _normalizeFieldName;
    FIELD_TYPES[_normalizeFieldName = normalizeFieldName(name)] || (FIELD_TYPES[_normalizeFieldName] = type);
  }
  function getFieldType(name) {
    return FIELD_TYPES[normalizeFieldName(name)];
  }

  // Images

  function getImageSizes(type) {
    var end = type.split('@')[1];
    var size = parseInt(end) || DEFAULT_SIZE;
    return RATIOS.map(function (ratio) {
      return size * ratio;
    });
  }

  // Pages

  var pages = data.pages || [];
  function addPage(page) {
    mergeData({
      pages: [].concat(_toConsumableArray(pages), [page])
    });
  }
  function updatePage(index, update) {
    mergeData({
      pages: (0, _array.replaceElement)(pages, index, update)
    });
  }
  function removePage(index) {
    mergeData({
      pages: (0, _array.removeElement)(pages, index)
    });
  }

  // Collections

  function getCollection(name) {
    return COLLECTIONS[name];
  }
  function setCollection(name, fields) {
    COLLECTIONS[name] || (COLLECTIONS[name] = fields);
  }
  function updateCollectionFields(collectionName, items) {
    var prefix = getFieldPrefix(collectionName);
    var fields = [].concat(_toConsumableArray(getFields().filter(function (field) {
      return !field.name.startsWith(prefix);
    })), _toConsumableArray(items.flatMap(function (item, i) {
      return Object.entries(item).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          field = _ref2[1];
        return _objectSpread(_objectSpread({}, field), {}, {
          name: getCollectionFieldName(collectionName, i, name)
        });
      });
    })));
    mergeData({
      fields: fields
    });
  }
  function getCollectionFieldName(collectionName, index, fieldName) {
    var prefix = getFieldPrefix(collectionName);
    return "".concat(prefix, "_").concat(index, "_").concat(fieldName);
  }
  function getCollectionItems(name) {
    var prefix = getFieldPrefix(name);
    var length = 0;
    var collectionFields = getFields().filter(function (field) {
      return field.name.startsWith(prefix);
    });
    var sparse = {};
    var _iterator = _createForOfIteratorHelper(collectionFields),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        var _parseFieldName = parseFieldName(field.name),
          _name = _parseFieldName.name,
          index = _parseFieldName.index;
        sparse[index] = _objectSpread(_objectSpread({}, sparse[index]), {}, _defineProperty({}, _name, field));
        length = Math.max(length, index + 1);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var items = [];
    for (var i = 0; i < length; i++) {
      items.push(sparse[i] || {});
    }
    return items;
  }

  // Publishing

  function canPublish() {
    return hasLocal();
  }
  function publish(_x) {
    return _publish.apply(this, arguments);
  }
  function _publish() {
    _publish = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(version) {
      var pages, fields;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (canPublish()) {
              _context.next = 2;
              break;
            }
            throw new Error('No changes to publish.');
          case 2:
            setPublishing(true);
            pages = data.pages, fields = data.fields;
            _context.next = 6;
            return (0, _api.request)({
              path: '/1/site/publish',
              method: 'POST',
              body: {
                version: version,
                pages: pages,
                fields: fields
              }
            });
          case 6:
            setPublishing(false);
            removeLocal();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _publish.apply(this, arguments);
  }
  function mergeData(update) {
    var merged = _objectSpread(_objectSpread({}, data), update);
    setData(merged);
    storeLocal(merged);
  }
  function reset() {
    removeLocal();
    setData(props.data);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DataContext.Provider, {
    value: {
      getField: getField,
      getFieldValue: getFieldValue,
      pages: pages,
      addPage: addPage,
      removePage: removePage,
      updatePage: updatePage,
      getCollection: getCollection,
      setCollection: setCollection,
      getCollectionItems: getCollectionItems,
      getCollectionFieldName: getCollectionFieldName,
      updateCollectionFields: updateCollectionFields,
      getPageField: getPageField,
      parseFieldName: parseFieldName,
      humanizeFieldName: humanizeFieldName,
      getImageSizes: getImageSizes,
      getFieldType: getFieldType,
      setFieldType: setFieldType,
      updateField: updateField,
      publish: publish,
      publishing: publishing,
      canPublish: canPublish,
      reset: reset
    },
    children: props.children
  });
}
var DEFAULT_SIZE = 500;
var RATIOS = [1, 2, 3];
function getLocal() {
  var str = _storage.localStorage.getItem('data');
  return str ? JSON.parse(str) : null;
}
function storeLocal(data) {
  _storage.localStorage.setItem('data', JSON.stringify(data));
}
function removeLocal() {
  _storage.localStorage.removeItem('data');
}
function hasLocal() {
  return !!getLocal();
}
function getData() {
  return window.__DATA__ || {};
}

// Field: "name"
// Pages: "$about_name"
// Collections: "$users_0_name"
var FIELD_NAME_REG = /^(?:\$([^_]+)(?:_(\d+))?_)?([^_]+)$/;
var FIELD_TYPES = {};
var COLLECTIONS = {};
function parseFieldName(fieldName) {
  var match = fieldName.match(FIELD_NAME_REG);
  var _match = _slicedToArray(match, 4),
    prefix = _match[1],
    digit = _match[2],
    name = _match[3];
  var type;
  var index;
  if (prefix && digit) {
    type = 'collection';
    index = Number(digit);
  } else if (prefix) {
    type = 'page';
  }
  return {
    type: type,
    index: index,
    name: name
  };
}
function normalizeFieldName(name) {
  name = name.replace(FIELD_NAME_REG, function (all, collection, num, field) {
    if (collection) {
      return "$".concat(collection, "_").concat(field);
    } else {
      return all;
    }
  });
  return name;
}
function humanizeFieldName(name) {
  var match = name.match(FIELD_NAME_REG);
  if (match) {
    var _match2 = _slicedToArray(match, 4),
      collection = _match2[1],
      num = _match2[2],
      field = _match2[3];
    if (collection && num && field) {
      num = Number(match[2]) + 1;
      name = "".concat(collection, " ").concat(num, " ").concat(field);
    }
  }
  name = (0, _startCase["default"])(name);
  name = name.replace(/Url/, 'URL');
  return name;
}
function getPageField(page, name) {
  return "".concat(getFieldPrefix(page), "_").concat(name);
}
function getFieldPrefix(str) {
  return "$".concat((0, _kebabCase["default"])(str));
}